import React from 'react';
//import { getBlockComponent } from '@benzinga/blocks';
import { CampaignifyBlock } from './Blocks/CampaignifyBlock';
import { ArticleData } from '@benzinga/article-manager';
import { Block } from '@benzinga/blocks';

const Primis = React.lazy(() =>
  import('@benzinga/ads').then(module => {
    return { default: module.Primis };
  }),
);

export interface Block {
  blockName: string;
}

export interface PrimisArticleBlock extends Block {
  id: string;
}

export interface ArticleBlockProps {
  block: any;
  node?: ArticleData;
}

export interface CampaignifyPlaceholderBlock extends Block {
  position: string;
  nodeID: number | string;
}

export type ArticleBlockType = Block | PrimisArticleBlock | CampaignifyPlaceholderBlock;

export const ArticleBlock: React.FC<ArticleBlockProps> = props => {
  const block = getArticleBlock(props);
  return block ? block : <Block {...props} getBlock={getArticleBlock} />;
};

export const getArticleBlock = ({
  block,
}: // node,
ArticleBlockProps) => {
  if (block.blockName === 'ad/campaign') {
    return <div className="bz-campaign" dangerouslySetInnerHTML={{ __html: block.value }} />;
  } else if (block.blockName === 'ad/primis') {
    return <Primis id={block.id} placeholderId="primis-article-video" renderOnEvent selector="#primis-article-video" />;
  } else if (block.blockName === 'ad/campaignify') {
    return <CampaignifyBlock nodeID={block.nodeID} placeholderId={block.position} ticker={block.ticker} />;
  }
  // return <p style={{ color: 'red' }}>{block.blockName}</p>;
  return null;
};
